const relativeTime = {
  now: "now",
  inMinutes: "in {n}m",
  inHours: "in {n}h",
} as const;
export default relativeTime;
